import React from 'react';
import Routes from './Routes/Routes.jsx';


function App() {
  return (
    <Routes />
  )
}

export default App;